import React from 'react';
import classNames from 'classnames';
import ErrorMessage from '../../common/components/EditorErrors/ErrorMessage';

import styles from '../CapabilitiesAssessmentEditor.module.scss';

/** The small "Title is required" under a page's title, when it's blank. */
function PageTitleError({ title }) {
  if ((title ?? '').trim().length > 0) {
    return null;
  }

  return (
    <div
      className={classNames(
        'invalid-feedback force-show',
        styles['page-title-error']
      )}
    >
      <ErrorMessage>Title is required</ErrorMessage>
    </div>
  );
}

export default PageTitleError;
